import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';

import { useLegalType } from '~/hooks/useHandbook';

interface Props {
  countryId: string | undefined;
  placeholder?: string;
  [x: string]: any;
}

const LegalTypeInput: FC<Props> = (props) => {
  const { solutionId, countryId, ...rest } = props;
  const { options, isLoading } = useLegalType(countryId);
  const { t } = useTranslation();

  return (
    <Select loading={isLoading} placeholder={t('companyLegalType')} options={options} {...rest} />
  );
};

export default LegalTypeInput;
